import { render, staticRenderFns } from "./RealityUpgradesTab.vue?vue&type=template&id=93ef030a&scoped=true&"
import script from "./RealityUpgradesTab.vue?vue&type=script&lang=js&"
export * from "./RealityUpgradesTab.vue?vue&type=script&lang=js&"
import style0 from "./RealityUpgradesTab.vue?vue&type=style&index=0&id=93ef030a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ef030a",
  null
  
)

export default component.exports